(function() {
  const sections = document.querySelectorAll('.bigmad-product');
  if (!sections.length) return;
  sections.forEach(initSection);

  function initSection(section) {
    const productJson = JSON.parse(section.querySelector('[data-product-json]').textContent);
    const variantInput = section.querySelector('[data-variant-id-input]');
    const optionInputs = section.querySelectorAll('[data-option-input]');
    const priceEl = section.querySelector('[data-price]');
    const comparePriceEl = section.querySelector('[data-compare-price]');
    const priceConsultEl = section.querySelector('[data-price-consult]');
    const discountBadgeEl = section.querySelector('[data-discount-badge]');
    const shipCalc = section.querySelector('[data-shipcalc]');
    const pixLabelEl = section.querySelector('[data-price-pix-label]');
    const installmentsEl = section.querySelector('[data-price-installments]');
    const installmentValueEl = section.querySelector('[data-installment-value]');
    
    // NOVO: Selecionando os novos elementos que criamos no HTML
    const basePriceEl = section.querySelector('[data-base-price]'); 
    const pixWrapperEl = section.querySelector('.bigmad-price-pix-wrapper'); 

    const pixPct = parseFloat(section.dataset.pixDiscount) || 0;
    const installmentsQty = parseInt(section.dataset.installments) || 12;

    const paidBlocks = section.querySelectorAll('[data-variant-toggle="paid"]');
    const consultBlocks = section.querySelectorAll('[data-variant-toggle="consult"]');

    const stockWrap = section.querySelector('[data-stock-wrap]');
    const addBtn = section.querySelector('[data-add-btn]');
    const addText = section.querySelector('[data-add-text]');
    const buyBtn = section.querySelector('[data-buy-now]');
    const productForm = section.querySelector('#bigmad-form');

    optionInputs.forEach(input => {
      input.addEventListener('change', () => {
        const fieldset = input.closest('.bigmad-option');
        fieldset.querySelectorAll('.bigmad-pill, .bigmad-swatch').forEach(el => {
          el.classList.toggle('is-selected', el.querySelector('input').checked);
        });
        const valueLabel = fieldset.querySelector('[data-option-value]');
        if (valueLabel) valueLabel.textContent = input.value;
        updateVariant();
        updateAvailability();
      });
    });

    function getSelectedOptions() {
      const opts = [];
      section.querySelectorAll('.bigmad-option').forEach(fs => {
        const checked = fs.querySelector('[data-option-input]:checked');
        opts.push(checked ? checked.value : null);
      });
      return opts;
    }

    function updateAvailability() {
      const selected = getSelectedOptions();
      const fieldsets = section.querySelectorAll('.bigmad-option');

      fieldsets.forEach((fs, optionIndex) => {
        const labels = fs.querySelectorAll('.bigmad-pill, .bigmad-swatch');
        labels.forEach(label => {
          const input = label.querySelector('[data-option-input]');
          if (!input) return;
          const testValue = input.value;

          const matchingVariant = productJson.variants.find(v => {
            return v.options.every((optVal, i) => {
              if (i === optionIndex) return optVal === testValue;
              return selected[i] == null || optVal === selected[i];
            });
          });

          const isAvailable = matchingVariant && matchingVariant.available;
          label.classList.toggle('is-unavailable', !isAvailable);
        });
      });
    }

    /** Alterna a página entre "com preço" e "sob consulta" */
    function applyConsultMode(isConsult) {
      paidBlocks.forEach(el => { el.hidden = isConsult; });
      consultBlocks.forEach(el => { el.hidden = !isConsult; });
      
      if (priceConsultEl) priceConsultEl.hidden = !isConsult;
      if (priceEl) priceEl.hidden = isConsult;
      if (pixLabelEl) pixLabelEl.hidden = isConsult;
      if (installmentsEl) installmentsEl.hidden = isConsult;
      
      // NOVO: Esconde os novos elementos visuais quando for Sob Consulta
      if (basePriceEl) basePriceEl.hidden = isConsult;
      if (pixWrapperEl) pixWrapperEl.hidden = isConsult;

      if (isConsult) {
        if (comparePriceEl) comparePriceEl.hidden = true;
        if (discountBadgeEl) discountBadgeEl.hidden = true;
      }
      section.classList.toggle('is-consult', isConsult);
    }

    function updateVariant() {
      const selectedOptions = getSelectedOptions();
      const variant = productJson.variants.find(v => v.options.every((opt, i) => opt === selectedOptions[i]));
      if (!variant) {
        if (addBtn) addBtn.disabled = true;
        if (addText) addText.textContent = 'Indisponível';
        return;
      }
      if (variantInput) variantInput.value = variant.id;
      const url = new URL(window.location);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);

      const isConsult = variant.price === 0;
      applyConsultMode(isConsult);

      if (!isConsult) {
        const hasPixDiscount = pixPct > 0;
        let displayPrice = variant.price;
        let crossedPrice = null;

        if (hasPixDiscount) {
          displayPrice = Math.round(variant.price * (1 - pixPct / 100));
          crossedPrice = variant.price;
        } else if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          crossedPrice = variant.compare_at_price;
        }

        if (priceEl) priceEl.textContent = formatMoney(displayPrice);
        if (installmentValueEl) installmentValueEl.textContent = formatMoney(Math.round(variant.price / installmentsQty));

        // Preço riscado: só aparece se houver desconto Pix OU promoção nativa do Shopify.
        // "no Pix" só aparece quando o desconto vem do metafield de Pix (pixPct é fixo do
        // produto, não muda por variante, mas o riscado pode mudar se a promoção nativa for
        // por variante).
        if (basePriceEl) {
          basePriceEl.hidden = crossedPrice === null;
          if (crossedPrice !== null) basePriceEl.textContent = formatMoney(crossedPrice);
        }
        if (pixLabelEl) pixLabelEl.hidden = !hasPixDiscount;

        // "onSale" aqui só é considerado quando NÃO há desconto Pix — mutuamente exclusivo.
        const onSale = !hasPixDiscount && variant.compare_at_price && variant.compare_at_price > variant.price;
        if (comparePriceEl) {
          comparePriceEl.hidden = !onSale;
          if (onSale) comparePriceEl.textContent = formatMoney(variant.compare_at_price);
        }
        if (discountBadgeEl) {
          discountBadgeEl.hidden = !onSale;
          if (onSale) {
            const pct = Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price);
            discountBadgeEl.textContent = `−${pct}%`;
          }
        }

        const defaultText = (addText && addText.dataset.defaultText) || 'Adicionar ao carrinho';
        if (variant.available) {
          if (addBtn) addBtn.disabled = false;
          if (buyBtn) buyBtn.disabled = false;
          if (addText) addText.textContent = defaultText;
        } else {
          if (addBtn) addBtn.disabled = true;
          if (buyBtn) buyBtn.disabled = true;
          if (addText) addText.textContent = 'Esgotado';
        }

        if (shipCalc) {
          if (variant.weight) shipCalc.dataset.weight = (variant.weight / 1000).toFixed(3);
          shipCalc.dataset.value = (variant.price / 100).toFixed(2);
          if (variant.sku) shipCalc.dataset.sku = variant.sku;
          const results = shipCalc.querySelector('[data-shipcalc-results]');
          if (results && results.innerHTML.trim() !== '') {
            results.innerHTML = '<p class="bigmad-shipcalc-note">Variante alterada — calcule o frete novamente.</p>';
          }
        }
      }

      updateStock(variant);
      if (variant.featured_media) goToMedia(variant.featured_media.id);
    }

    function updateStock(variant) {
      if (!stockWrap) return;
      const inText = stockWrap.dataset.textIn || 'Em estoque';
      const lowText = stockWrap.dataset.textLow || 'Últimas {n} unidades';
      const outText = stockWrap.dataset.textOut || 'Esgotado';
      let html = '';
      if (!variant.available) {
        html = `<span class="bigmad-stock-dot bigmad-stock-dot--out"></span><span class="bigmad-stock-text">${outText}</span>`;
      } else if (variant.inventory_management === 'shopify' && variant.inventory_quantity > 0 && variant.inventory_quantity <= 5) {
        html = `<span class="bigmad-stock-dot bigmad-stock-dot--low"></span><span class="bigmad-stock-text">${lowText.replace('{n}', variant.inventory_quantity)}</span>`;
      } else {
        html = `<span class="bigmad-stock-dot bigmad-stock-dot--in"></span><span class="bigmad-stock-text">${inText}</span>`;
      }
      stockWrap.innerHTML = html;
    }

    function formatMoney(cents) {
      const value = cents / 100;
      return value.toLocaleString('pt-BR', { style: 'currency', currency: window.Shopify?.currency?.active || 'BRL' });
    }

    const track = section.querySelector('[data-gallery-track]');
    const prevBtn = section.querySelector('[data-gallery-prev]');
    const nextBtn = section.querySelector('[data-gallery-next]');

    function scrollByOne(direction) {
      if (!track) return;
      const slide = track.querySelector('.bigmad-gallery-slide');
      if (!slide) return;
      const slideWidth = slide.getBoundingClientRect().width + 4;
      track.scrollBy({ left: slideWidth * direction, behavior: 'smooth' });
    }
    if (prevBtn) prevBtn.addEventListener('click', () => scrollByOne(-1));
    if (nextBtn) nextBtn.addEventListener('click', () => scrollByOne(1));

    function updateArrows() {
      if (!track || !prevBtn || !nextBtn) return;
      prevBtn.disabled = track.scrollLeft <= 5;
      nextBtn.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 5;
    }
    if (track) { track.addEventListener('scroll', updateArrows); updateArrows(); }

    function goToMedia(mediaId) {
      const target = section.querySelector(`[data-media-id="${mediaId}"]`);
      if (!target || !track) return;
      track.scrollTo({ left: target.offsetLeft - track.offsetLeft, behavior: 'smooth' });
    }

    section.querySelectorAll('[data-video]').forEach(video => {
      const io = new IntersectionObserver(entries => {
        entries.forEach(e => { if (e.isIntersecting) video.play().catch(() => {}); else video.pause(); });
      }, { threshold: 0.5 });
      io.observe(video);
    });
    section.querySelectorAll('[data-video-mute]').forEach(btn => {
      btn.addEventListener('click', () => {
        const video = btn.previousElementSibling;
        if (!video) return;
        video.muted = !video.muted;
      });
    });
    section.querySelectorAll('[data-ext-video]').forEach(wrap => {
      wrap.addEventListener('click', () => {
        const host = wrap.dataset.host;
        const id = wrap.dataset.id;
        let url = '';
        if (host === 'youtube') url = `https://www.youtube.com/embed/${id}?autoplay=1&rel=0`;
        else if (host === 'vimeo') url = `https://player.vimeo.com/video/${id}?autoplay=1`;
        if (!url) return;
        wrap.innerHTML = `<iframe src="${url}" frameborder="0" allow="autoplay; encrypted-media; picture-in-picture" allowfullscreen style="width:100%;height:100%;"></iframe>`;
      }, { once: true });
    });

    const qtyInput = section.querySelector('[data-qty-input]');
    const qtyMinus = section.querySelector('[data-qty-minus]');
    const qtyPlus = section.querySelector('[data-qty-plus]');
    if (qtyMinus && qtyInput) qtyMinus.addEventListener('click', () => { qtyInput.value = Math.max(1, parseInt(qtyInput.value) - 1); });
    if (qtyPlus && qtyInput) qtyPlus.addEventListener('click', () => { qtyInput.value = parseInt(qtyInput.value) + 1; });

    if (buyBtn && productForm) {
      buyBtn.addEventListener('click', async () => {
        if (buyBtn.disabled) return;
        buyBtn.disabled = true;
        const formData = new FormData(productForm);
        try {
          await fetch('/cart/add.js', { method: 'POST', body: formData });
          window.location.href = '/checkout';
        } catch (err) {
          buyBtn.disabled = false;
          alert('Erro ao processar. Tente novamente.');
        }
      });
    }

    if (productForm) {
      productForm.addEventListener('submit', async e => {
        e.preventDefault();
        if (addBtn.disabled) return;
        addBtn.disabled = true;
        const originalText = addText.textContent;
        addText.textContent = 'Adicionando...';
        const formData = new FormData(productForm);
        try {
          const res = await fetch('/cart/add.js', { method: 'POST', body: formData });
          if (!res.ok) throw new Error('Falha');
          addText.textContent = '✓ Adicionado';
          if (window.PUB_SUB_EVENTS && window.publish) {
            window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'bigmad' });
          }
          document.dispatchEvent(new CustomEvent('cart:added'));
          setTimeout(() => { addText.textContent = originalText; addBtn.disabled = false; }, 1800);
        } catch (err) {
          addText.textContent = 'Erro, tente novamente';
          setTimeout(() => { addText.textContent = originalText; addBtn.disabled = false; }, 1800);
        }
      });
    }

    updateAvailability();
    updateVariant();
  }

  document.querySelectorAll('[data-accordion]').forEach(accordion => {
    const mode = accordion.dataset.mode || 'single';
    const toggles = accordion.querySelectorAll('[data-accordion-toggle]');

    toggles.forEach(toggle => {
      toggle.addEventListener('click', e => {
        e.preventDefault();
        const isOpen = toggle.getAttribute('aria-expanded') === 'true';

        if (mode === 'single' && !isOpen) {
          toggles.forEach(t => {
            if (t !== toggle) t.setAttribute('aria-expanded', 'false');
          });
        }

        toggle.setAttribute('aria-expanded', String(!isOpen));
      });
    });
  });
})();